// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"079cf741","205":"aa7028c6","292":"c5c409c8","445":"ed732318","456":"68d586d7","495":"fd4632ea","902":"457173f3","912":"35448a29"}[chunkId] + ".chunk.css";
};